import * as React from 'react';
import { render } from 'react-dom';

import { saveOfferIdUserOpenedPhoneIn } from '../../utils/call_now';
import { ICallNowPopupProps } from '../common/components/call_now_popup/call_now_popup';

function loadComponents(): Promise<{[key: string]: React.ComponentClass<any>}> {
  return new Promise((resolve, reject) => {
    require.ensure([
      '../common/components/call_now_popup/call_now_popup',
    ], () => {
      resolve({
        CallNowPopup: require('../common/components/call_now_popup/call_now_popup').default,
      })
    });
  });
}

export default function initCallNowPopup() {
  (window as any).renderCallNowPopup = (element: Element, props: ICallNowPopupProps) => {
    loadComponents()
      .then(({ CallNowPopup }) => {
        render(<CallNowPopup {...props} />, element);
      });
  };
}

export function makeCallNowApiGlobal() {
  (window as any)._callNowApi = {
    saveOfferIdUserOpenedPhoneIn,
  }
}



// WEBPACK FOOTER //
// ./src/bundles/call_now/index.tsx